// utils/pickBySeed.js
export function pickOneBySeed(array, seed) {
  if (!array.length) return null;
  const index = seed % array.length;
  return array[index];
}